import { motion } from 'motion/react';

import OverlaySection from '@/components/OverlaySection.tsx';
import Paragraph from '@/components/text/Paragraph.tsx';

import { EnrichedPractitionerData } from '@/models/appointment/EnrichedPractitionerData.ts';

import { EnrichedAppointmentWithBookingStatus } from '@/stores/bookingStore.ts';

import {
    CollectionKind,
    buildSeriesDetailsLabel,
    formatCollectionDateRange,
    formatCollectionLabel,
} from '@/utils/collection-utils.ts';

type Props = {
    mode: CollectionKind;
    appointments: EnrichedAppointmentWithBookingStatus[];
    formOptionData: EnrichedPractitionerData;
};

export const CollectionSummaryCard = (props: Props) => {
    const { mode, appointments, formOptionData } = props;
    const count = appointments.length;
    const dateRange = formatCollectionDateRange(appointments.map((appointment) => appointment.form_data.date_time));
    const seriesDetails = buildSeriesDetailsLabel(mode, appointments, formOptionData);

    return (
        <OverlaySection className="relative overflow-hidden shadow-sm">
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.2, delay: 0.3 }}
                className="w-full"
            >
                <div className="flex w-full items-center justify-between gap-3">
                    <div className="flex flex-col gap-2">
                        <Paragraph className="text-lg text-slate-500">{formatCollectionLabel(mode, count)}</Paragraph>
                        {seriesDetails && <div className="text-sm text-slate-500">{seriesDetails}</div>}
                        {dateRange && <Paragraph>{dateRange}</Paragraph>}
                    </div>
                </div>
            </motion.div>
        </OverlaySection>
    );
};
